var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chileTable"},[_c('DealerStat',{attrs:{"groupName":_vm.groupName,"params":_vm.params,"isRoot":_vm.isRoot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }